module.exports = __webpack_public_path__ + "img/operate-3.bc1d4e11.gif";